export default "/static/1760d15c20e2ff23.png"